import { updateWorkstation } from '@connect-x-app/hybrid-data-access';
import { QueryKeys } from '@connect-x-app/shared-domain-models';
import { useMutation } from '@tanstack/react-query';

export const useUpdateWorkstation = (onSuccess?: () => void) =>
  useMutation({
    mutationFn: updateWorkstation,
    mutationKey: [QueryKeys.UPDATE_WORKSTATION],
    onSuccess: onSuccess,
  });
